import React, { Component } from 'react'
import { message, Button, Input, Form, Upload, } from 'antd';
import { updateMember } from './../../actions/member'
import { uploadMutipleFile } from '../../actions/app'
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons';
import { connect } from "react-redux"

class Profile extends Component {
  constructor(props) {
    super(props)
    const { member } = props
    this.state = {
      loadingImage: false,
      data: {
        address: member.address && member.address !== "undefined" ? member.address : "",
        job: member.job && member.job !== "undefined" ? member.job : "",
        phone: member.phone && member.phone !== "undefined" ? member.phone : "",
        nickname: member.nickname && member.nickname !== "undefined" ? member.nickname : "",
      },
      imgUrl: member.imgUrl || ''
    }

  }

  handleSubmit(values) {
    const { member, updateMember, } = this.props
    const { imgUrl } = this.state
    const newMember = {
      displayName: member.displayName || '',
      email: member.email || '',
      imgUrl: member.imgUrl || imgUrl,
      nickname: member.nickname || '',
      phone: member.phone || '',
      job: member.job || '',
      uid: member.uid,
      role: member.role,
      groupIds: member.groupIds || [],
      followIds: member.followIds || [],
    }
    const newData = {
      ...newMember,
      ...values,
      imgUrl: imgUrl
    }
    updateMember(member.uid, newData).then(() => {
      message.success("Save profile successfully")
    })
  }

  beforeUpload(file) {

    const isLt4M = file.size / 1024 / 1024 < 4
    if (!isLt4M) {
      message.error('Image must smaller than 4MB!')
    }
    return isLt4M
  }

  handleUploadImage(file) {
    uploadMutipleFile(file, `${file.uid}/app/img`).then(result => {
      const { url, isSuccess } = result

      if (isSuccess) {
        this.setState({
          imgUrl: url
        })
      }
    })
  }

  handleChangeImage = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loadingImage: true })
      return
    }
    if (info.file.status === 'done' || info.file.status === 'error') {
      // Get this url from response in real world.
      this.handleUploadImage(info.file.originFileObj)
      this.getBase64(info.file.originFileObj, _ => this.setState({
        loadingImage: false,
      }
      ))
    }
  };

  getBase64(img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }


  render() {
    const { imgUrl, loadingImage, data } = this.state
    const uploadButton = (
      <div>
        {
          loadingImage ? (<LoadingOutlined></LoadingOutlined>) : (<PlusOutlined></PlusOutlined>)
        }

        <div className="ant-upload-text">Drop an image here.</div>
      </div>
    )
    return (
      <div className="row">

        <div className="col-12 col-md-6">
          <Form initialValues={data} layout="vertical" onFinish={(values) => { this.handleSubmit(values) }}>
            <Form.Item
              label="Avatar"
            >
              <Upload
                name="imgUrl"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={false}
                action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                beforeUpload={(file) => { this.beforeUpload(file) }}
                onChange={(info) => { this.handleChangeImage(info) }}
              >
                {imgUrl ? <img src={imgUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
              </Upload>
            </Form.Item>


            <Form.Item
              name="nickname" rules={
                [{ required: true, message: 'Please input your nickname!', whitespace: true }]
              }
              label={
                "Nickname"
              }
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              name="phone"
              label={
                "Phone number"
              }
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item
              name="address"
              label={
                "Your address"
              }
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              name="job"
              label={
                "Your job"
              }
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item >
              <Button type="primary" htmlType="submit">
                Save
           </Button>
            </Form.Item>
          </Form>

        </div>
        <div className="col-12 col-md-6"></div>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  member: state.member || {},
});

const mapDispatchToProps = dispatch => {
  return {
    updateMember: (id, data) => updateMember(id, data)
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Profile)